import { render, staticRenderFns } from "./DoughnutStats.vue?vue&type=template&id=6d2c932c&scoped=true"
import script from "./DoughnutStats.vue?vue&type=script&lang=js"
export * from "./DoughnutStats.vue?vue&type=script&lang=js"
import style0 from "./DoughnutStats.vue?vue&type=style&index=0&id=6d2c932c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c932c",
  null
  
)

export default component.exports